import React from 'react';

const Footer = () => {
    return (
        <div className='footer'>
            <div className='spacer' ></div>
            <p>Abhinav Tripathi • Muazzam Faraaz • Vaibhav Suwalka • Saksham Anand • Namya Shah</p>
        </div>
    );
};

export default Footer;